import React from "react";
import {
  AlertsProvider,
  AuthProvider,
  DialogProvider,
  LoaderProvider,
} from "../../context";

const Layout = ({ children }) => {
  return (
    <React.Fragment>
      <LoaderProvider>
        <AlertsProvider>
          <DialogProvider>
            <AuthProvider>{children}</AuthProvider>
          </DialogProvider>
        </AlertsProvider>
      </LoaderProvider>
    </React.Fragment>
  );
};

export default Layout;
